export class NotificationListConfig {
  read: boolean;
  limit?: number;
  offset?: number;
}
